/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FreightClaimLineItem } from './FreightClaimLineItem';
import {
    FreightClaimLineItemFromJSON,
    FreightClaimLineItemFromJSONTyped,
    FreightClaimLineItemToJSON,
    FreightClaimLineItemToJSONTyped,
} from './FreightClaimLineItem';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { FreightClaimState } from './FreightClaimState';
import {
    FreightClaimStateFromJSON,
    FreightClaimStateFromJSONTyped,
    FreightClaimStateToJSON,
    FreightClaimStateToJSONTyped,
} from './FreightClaimState';

/**
 * 
 * @export
 * @interface FreightClaim
 */
export interface FreightClaim {
    /**
     * 
     * @type {string}
     * @memberof FreightClaim
     */
    freightClaimId?: string;
    /**
     * 
     * @type {Date}
     * @memberof FreightClaim
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof FreightClaim
     */
    shipmentId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightClaim
     */
    companyId?: string;
    /**
     * 
     * @type {FreightClaimState}
     * @memberof FreightClaim
     */
    freightClaimState?: FreightClaimState;
    /**
     * 
     * @type {string}
     * @memberof FreightClaim
     */
    carrierIdentifier?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightClaim
     */
    proNumber?: string;
    /**
     * 
     * @type {Array<FreightClaimLineItem>}
     * @memberof FreightClaim
     */
    freightClaimLineItems?: Array<FreightClaimLineItem>;
    /**
     * 
     * @type {string}
     * @memberof FreightClaim
     */
    claimDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof FreightClaim
     */
    claimInternalNotes?: string;
    /**
     * 
     * @type {Currency}
     * @memberof FreightClaim
     */
    claimCurrency?: Currency;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreightClaim
     */
    originalInvoiceFiles?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreightClaim
     */
    photoFiles?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FreightClaim
     */
    otherDocumentFiles?: Array<string>;
}



/**
 * Check if a given object implements the FreightClaim interface.
 */
export function instanceOfFreightClaim(value: object): value is FreightClaim {
    return true;
}

export function FreightClaimFromJSON(json: any): FreightClaim {
    return FreightClaimFromJSONTyped(json, false);
}

export function FreightClaimFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreightClaim {
    if (json == null) {
        return json;
    }
    return {
        
        'freightClaimId': json['freightClaimId'] == null ? undefined : json['freightClaimId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'shipmentId': json['shipmentId'] == null ? undefined : json['shipmentId'],
        'companyId': json['companyId'] == null ? undefined : json['companyId'],
        'freightClaimState': json['freightClaimState'] == null ? undefined : FreightClaimStateFromJSON(json['freightClaimState']),
        'carrierIdentifier': json['carrierIdentifier'] == null ? undefined : json['carrierIdentifier'],
        'proNumber': json['proNumber'] == null ? undefined : json['proNumber'],
        'freightClaimLineItems': json['freightClaimLineItems'] == null ? undefined : ((json['freightClaimLineItems'] as Array<any>).map(FreightClaimLineItemFromJSON)),
        'claimDescription': json['claimDescription'] == null ? undefined : json['claimDescription'],
        'claimInternalNotes': json['claimInternalNotes'] == null ? undefined : json['claimInternalNotes'],
        'claimCurrency': json['claimCurrency'] == null ? undefined : CurrencyFromJSON(json['claimCurrency']),
        'originalInvoiceFiles': json['originalInvoiceFiles'] == null ? undefined : json['originalInvoiceFiles'],
        'photoFiles': json['photoFiles'] == null ? undefined : json['photoFiles'],
        'otherDocumentFiles': json['otherDocumentFiles'] == null ? undefined : json['otherDocumentFiles'],
    };
}

  export function FreightClaimToJSON(json: any): FreightClaim {
      return FreightClaimToJSONTyped(json, false);
  }

  export function FreightClaimToJSONTyped(value?: FreightClaim | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'freightClaimId': value['freightClaimId'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'shipmentId': value['shipmentId'],
        'companyId': value['companyId'],
        'freightClaimState': FreightClaimStateToJSON(value['freightClaimState']),
        'carrierIdentifier': value['carrierIdentifier'],
        'proNumber': value['proNumber'],
        'freightClaimLineItems': value['freightClaimLineItems'] == null ? undefined : ((value['freightClaimLineItems'] as Array<any>).map(FreightClaimLineItemToJSON)),
        'claimDescription': value['claimDescription'],
        'claimInternalNotes': value['claimInternalNotes'],
        'claimCurrency': CurrencyToJSON(value['claimCurrency']),
        'originalInvoiceFiles': value['originalInvoiceFiles'],
        'photoFiles': value['photoFiles'],
        'otherDocumentFiles': value['otherDocumentFiles'],
    };
}

